import { render, staticRenderFns } from "./TeleMarketSmsTemplateEdit.vue?vue&type=template&id=01bb7ed2&scoped=true"
import script from "./TeleMarketSmsTemplateEdit.vue?vue&type=script&lang=js"
export * from "./TeleMarketSmsTemplateEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01bb7ed2",
  null
  
)

export default component.exports